import React, { FC }               from 'react';
import { Header }                  from 'semantic-ui-react';
import { HelpAndSupportStatement } from '../../../../components/util/messaging/HelpAndSupportStatement';
import { MessageInRotatingHex }    from '../../../../components/util/messaging/MessageInRotatingHex';
import { SemanticUIColor }         from '../../../../../types';

interface Props {}

const defaultProps: Props = {}

const EmptyOrganizationList: FC<Props> = ( props ) => {
	
	return (
		
		<MessageInRotatingHex messageHoverEffect={ false } hexColor={ SemanticUIColor.TEAL}>
			
			<Header textAlign={ 'center' } as={ 'h3' } content={ 'No Projects Found!' }/>
			
			<p className={ 'text-center' }>
				Please contact your
				{ ' ' }
				<HelpAndSupportStatement
					withInlineCasing={ true }
					withPreAmble={ false }
					contactName={ 'customer success representative' }
					withPostAmble={ false }
				/>
				{ ' ' }
				for help creating or joining an organization with an active project.
			</p>
		</MessageInRotatingHex>
	);
};

EmptyOrganizationList.defaultProps = defaultProps;

export { EmptyOrganizationList }
